module.exports = __webpack_public_path__ + "static/media/tloczenie-atmo.99ae1af9.svg";